import { useMemo } from "react";
import { View } from "react-native";
import { LinearTransition } from "react-native-reanimated";
import OpacityView from "src/components/OpacityView";
import Touchable from "src/components/Touchable";
import { AnimatePresence, Image } from "src/swsh-native";

const SIZE_PERCENTAGE = 0.7;
const ReactionPreviewProfilePictures = ({
	users,
	size = 32,
	numProfilePictures = 3,
	onPress,
}: {
	users: (
		| {
				userId: string;
				profilePicture?:
					| {
							url?: string | null | undefined;
					  }
					| null
					| undefined;
		  }
		| null
		| undefined
	)[];
	/**
	 * The size of the profile pictures.
	 */
	size?: number;
	numProfilePictures?: number;
	onPress?: () => void;
}) => {
	const usableUrls = useMemo<string[]>(
		() =>
			users
				.map((user) => user?.profilePicture?.url)
				.filter((url): url is string => Boolean(url))
				.slice(0, numProfilePictures),
		[users, numProfilePictures],
	);
	return (
		<View
			style={[
				{
					flexDirection: "row",
					alignItems: "flex-end",
					height: size,
				},
			]}
		>
			<AnimatePresence>
				{usableUrls.map((url, i) => (
					<Touchable
						key={url}
						animation="None"
						onPress={onPress}
						testID="ReactedPfp"
						containerStyle={{
							position: "absolute",
							right: i * size * SIZE_PERCENTAGE,
							zIndex: usableUrls.length - i,
						}}
					>
						<OpacityView
							nativeLayout={LinearTransition}
							webLayoutId={url}
							style={{
								width: size,
								height: size,
							}}
						>
							<Image
								alt="User profile picture"
								src={url}
								dim={{
									width: size,
									height: size,
								}}
								style={{
									borderRadius: size / 2,
									borderWidth: 2,
									borderColor: "#FFFFFF",
								}}
							/>
						</OpacityView>
					</Touchable>
				))}
			</AnimatePresence>
		</View>
	);
};
export default ReactionPreviewProfilePictures;
